<template>
    <div class="switchPanel_main" :class="{'cn':version == '1'}">
        <div class="switchPanel_left">
            <!-- <side-bar></side-bar> -->
        </div>
        <div class="switchPanel_right">
            <div class="switchPanel_right_top">
                <div class="right_top_l">
                    <el-select v-model="buildId" @change="buildIdChange">
                        <el-option
                          v-for="item in buildNav"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                    </el-select>
                    <el-input :placeholder="$t('App.lights.text24')" v-model="keywords" @keyup.native="getLightListKeyUp($event)" class="input-with-select">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="getLightList()"></i>
                    </el-input>
                </div>
            </div>
            <div class="switchPanel_right_main">
                <div class="main_top">
                    <div class="main_top_l">
                        <div class="div1"><span>{{$t('App.sideBar.text5')}}</span></div>
                        <div class="div2">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('App.lights.text10')}}</el-checkbox>
                            <div class="btn" @click="postDelLight(checkList,'batch')">
                                <i class="iconfont icon-delete"></i>
                                <span>{{$t('App.lights.text1')}}</span>
                            </div>
                            <!-- <div class="btn" @click="postReData(checkList)" v-loading="reDataIndex>0">
                                <span>Refresh</span>
                            </div> -->
                        </div>
                    </div>
                    <div class="main_top_r">
                        <div class="btn" @click="lightsFun()"><img :src="img_lights_0"><span>{{$t('App.lights.text5')}}</span></div>
                    </div>
                </div>
                <div class="main_cont">
                    <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
                            <!-- element-loading-background="rgba(0, 0, 0, 0.5)" -->
                        <el-table
                            ref="lightDataList"
                            v-loading="loading.lightDataList"
                            height="100%"
                            @cell-mouse-enter="tableEnter"
                            @cell-mouse-leave="tableLeave"
                            :data="lightDataList">
                            <el-table-column
                                :label="$t('App.lights.text33')"
                                :prop="'index'"
                                align="left"
                                header-align="center"
                                :min-width="6*remRatio">
                                <template slot-scope="scope">
                                    <el-checkbox :label="scope.row.id" :key="scope.row.id">{{scope.row.webIndex}}</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="$t('App.room.text42')"
                                :prop="'name'"
                                header-align="left"
                                align="left"
                                :show-overflow-tooltip="true"
                                :min-width="7*remRatio">
                            </el-table-column>
                            <el-table-column
                                :label="$t('App.room.text43')"
                                :prop="'deviceId'"
                                align="center"
                                :show-overflow-tooltip="true"
                                :min-width="7*remRatio">
                            </el-table-column>
                            <el-table-column
                                :label="$t('App.room.text29')"
                                :prop="'floor'"
                                align="center"
                                :show-overflow-tooltip="true"
                                :min-width="5*remRatio">
                                 <template slot="header" slot-scope="scope">
                                    <div class="floor_header" @click="floorTypeFun(scope)">
                                        <p><span>{{floorName}}</span><i class="el-icon-arrow-down"></i></p>
                                        <el-select v-model="floorId" placeholder="" @change="floorIdChange" ref="floorRef">
                                            <el-option
                                              v-for="item in tableFloorNav"
                                              :key="item.id"
                                              :label="item.name"
                                              :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="$t('App.room.text30')"
                                :prop="'roomNumber'"
                                align="center"
                                :show-overflow-tooltip="true"
                                :min-width="5*remRatio">
                                 <template slot="header" slot-scope="scope">
                                    <div class="floor_header" @click="roomTypeFun(scope)">
                                        <p><span>{{roomName}}</span><i class="el-icon-arrow-down"></i></p>
                                        <el-select v-model="roomId" placeholder="" @change="roomIdChange" ref="roomRef">
                                            <el-option
                                              v-for="item in tableRoomNav"
                                              :key="item.id"
                                              :label="item.number"
                                              :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-for="(item) in lightArr"
                                :key="'table_'+item.prop"
                                :prop="item.prop"
                                :label="item.label"
                                :align="item.align?item.align:'center'"
                                :width="item.width"
                                :show-overflow-tooltip="true"
                                :min-width="item.minWidth">
                                    <template slot-scope="scope">
                                        <div v-if="item.type != 1">{{scope.row[item.prop]}}{{item.unit?item.unit:''}}</div>
                                        <!-- <div v-if="item.prop == 'online'" class="online">
                                            <img :src="require('../../img/status_'+scope.row.online+'.png')">
                                        </div> -->
                                        <!-- <div v-if="item.prop == 'online'">{{onlineArr[scope.row[item.prop]]}}</div> -->
                                        <div v-if="item.prop == 'online'" class="online">
                                            <template>
                                                <i v-if="scope.row.blueStatus=='0'" class="iconfont icon-lanyax" style="color:'rgba(163,175,187,1)'"></i>
                                                <i v-if="scope.row.blueStatus=='1'" class="iconfont icon-lanyax" :style="{'color': version=='0'?'rgba(5, 207, 171, 1)':'#8266C7'}"></i>
                                                <span>|</span>
                                                <i v-if="scope.row.online=='0'" class="iconfont icon-disconnect" style="color:'rgba(163,175,187,1)'"></i>
                                                <i v-if="scope.row.online=='1'" class="iconfont icon-connectx" :style="{'color': version=='0'?'rgba(5, 207, 171, 1)':'#8266C7'}"></i>
                                            </template>
                                        </div>
                                        <div v-if="item.prop == 'alarmStatus'" class="alarmStatus">
                                            <span :class="'text_'+scope.row[item.prop]" @click="linkToFun('/service',scope.row)">{{scope.row[item.prop]==0?'normal':scope.row.alarmInfo}}<i class="iconfont icon-weixiu1" v-if="scope.row[item.prop] == 1"></i></span>
                                        </div>
                                        <div v-if="item.prop == 'brightness'" class="brightness">
                                            <el-input-number :class="{'input_loading':scope.row.brightnessLoading}" v-model="scope.row.brightness_" :min="0" :max="100" :controls="false" @blur="postLampLight(scope.row)"></el-input-number>
                                            <span class="text" :class="{'loading':scope.row.brightnessLoading}">{{scope.row[item.prop]}}%</span>
                                            <el-popover
                                              placement="bottom"
                                              trigger="click"
                                              :disabled="scope.row.brightnessLoading"
                                              popper-class="brightness_slider">
                                                <div class="slider_box">
                                                    <el-slider v-model="scope.row.brightness_" @change="postLampLight(scope.row)" :step="1" :min="0" :max="100"></el-slider><span class="text">{{scope.row.brightness_}}%</span>
                                                </div>
                                                <span class="btn_img" slot="reference" v-loading="scope.row.brightnessLoading">
                                                    <span class="bg"></span>
                                                    <i class="iconfont icon-setting"></i>
                                                </span>
                                            </el-popover>
                                        </div>
                                        <div v-if="item.prop == 'color'" class="color">
                                            <span class="text">{{scope.row[item.prop]}}K</span>
                                            <el-popover
                                              placement="bottom"
                                              trigger="click"
                                              :disabled="scope.row.colorLoading"
                                              popper-class="color_slider">
                                                <div class="slider_box">
                                                    <el-slider v-model="scope.row.color_" @change="postLampColor(scope.row)" :step="300" :min="3000" :max="6000"></el-slider><span class="text">{{scope.row.color_}}</span>
                                                </div>
                                                <span class="btn_img" slot="reference" v-loading="scope.row.colorLoading">
                                                    <span class="bg"></span>
                                                    <i class="iconfont icon-setting"></i>
                                                </span>
                                            </el-popover>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                align="center"
                                :min-width="10*remRatio"
                                :label="'Operation'">
                                <template slot-scope="scope">
                                    <span class="btn" @click="editFun(scope.row)" :title="$t('App.lights.text7')">
                                        <i class="iconfont icon-bianji"></i>
                                    </span>
                                    <!-- <span class="btn" @click="historySee(scope.row)" title="History">
                                        <i class="iconfont icon-history"></i>
                                    </span>
                                    <span class="btn" @click="upgradeFun(scope.row)" title="Update">
                                        <i class="iconfont icon-gujianbanbenshengji"></i>
                                    </span> -->
                                    <span class="btn" @click="centralizedSetting(scope.row)" :title="$t('App.airPurifiers.text1')">
                                        <i class="iconfont icon-control-fill"></i>
                                    </span>
                                    <span class="btn" @click="postDelLight(scope.row)" :title="$t('App.lights.text1')">
                                        <i class="iconfont icon-delete"></i>
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-checkbox-group>
                    <div class="pagination_box">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <!-- 添加编辑灯 -->
        <div class="switchPanel_wrap scrollbar_style" v-show="lightsTkShowbg">
            <div class="switchPanel_wrap_bg" @click="lightsTkClose()"></div>
            <div class="switchPanel_box" :class="{'switchPanel_tk_show':lightsTkShow}">
                <div class="switchPanel_title">
                    <span class="span1">{{lightTkTitle}}</span>
                    <span class="span2" @click="lightsTkClose()">{{$t('App.close')}}</span>
                </div>
                <div class="form">
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text42')}}</span>
                        <el-input v-model="lightsForm.name" placeholder="Please enter device name"></el-input>
                    </div>
                    <!-- <div class="form_item">
                        <span class="laber">{{$t('App.room_light.text57')}}</span>
                        <el-dropdown @command="commandModel" trigger="click" @visible-change="commandHide('dropdown_switchPanel_model')">
                            <span class="span1">{{lightsFormModelName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_switchPanel_model">
                                <el-dropdown-item v-for="item in modelNav" :command="item" :key="'floor'+item.id" :class="{'select':item.id==lightsForm.model}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div> -->
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text43')}}</span>
                        <el-input v-model="lightsForm.deviceId" placeholder="Please enter device id"></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room_light.text58')}}</span>
                        <el-input v-model="lightsForm.gatewayId" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text29')}}</span>
                        <el-dropdown @command="commandFloor" trigger="click" @visible-change="commandHide('dropdown_switchPanel_floor')">
                            <span class="span1">{{lightsFormFloorName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_switchPanel_floor">
                                <el-dropdown-item v-for="item in floorNav" :command="item" :key="'floor'+item.id" :class="{'select':item.id==lightsForm.floorId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text30')}}</span>
                        <el-dropdown @command="commandRoom" trigger="click" @visible-change="commandHide('dropdown_switchPanel_room')">
                            <span class="span1">{{lightsFormRoomName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_switchPanel_room">
                                <el-dropdown-item v-for="item in roomNav" :command="item" :key="'room'+item.id" :class="{'select':item.id==lightsForm.roomId}">{{item.number}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                   <!--  <div class="form_item" v-if="lightTkTitle == $t('App.lights.text36')">
                        <span class="laber">Hardware version</span>
                        <span>{{software}}</span>
                    </div>
                    <div class="form_item" v-if="lightTkTitle == $t('App.lights.text36')">
                        <span class="laber">Firmware version</span>
                        <span>{{software}}</span>
                    </div> -->

                </div>
                <div class="btn_box">
                    <div class="btn" @click="postSaveLight()">{{$t('App.room.text35')}}</div>
                </div>
            </div>
        </div>

        <!-- 情景设置 -->
        <div class="centralizedSetting_wrap scrollbar_style" v-show="centralizedSettingTkShowbg">
            <div class="centralizedSetting_wrap_bg" @click="centralizedSettingTkClose()"></div>
            <div class="centralizedSetting_box" :class="{'centralizedSetting_tk_show':centralizedSettingTkShow}">
                <div class="centralizedSetting_title">
                    <span class="span1">Centralized setting</span>
                    <span class="span2" @click="centralizedSettingTkClose()">{{$t('App.close')}}</span>
                </div>
                <div class="form">
                    <div class="form_item" v-for="item in centralizedSettingForm_for" :key="item.title">
                        <div class="form_item_title">{{item.title}}</div>
                        <div class="form_item_box">
                            <el-select v-model="centralizedSettingForm[item.key]">
                                <el-option
                                  v-for="item in centralizedOption"
                                  :key="item.id"
                                  :label="item.name"
                                  :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="centralizedSettingSave()" v-loading="loading.centralizedSettingSave">{{$t('App.room.text35')}}</div>
                </div>
            </div>
        </div>
        <!-- <button type="button" id="btn2" style="display: none"></button> -->
    </div>
</template>

<script type="text/javascript">
    // import sideBar from '../components/sideBar.vue'
    import { mapGetters } from 'vuex'
    import allUrl from '../../api/allUrl.js'
    import base from '../../api/base.js'
    export default {
        name:'lights',
        data () {
            return{
                buildId:'',
                buildNav:[],
                keywords:'',
                floorNav:[],
                roomNav:[],

                checkAll:false,
                isIndeterminate:false,
                checkList:[],

                lightId:'',
                lightArr:[],
                lightDataList:[],
                lightDataIdList:[],
                onlineArr:['Off-line','On-line'],
                tableShowId:'',

                floorName:'Floor',
                floorId:'',
                roomName:'Room',
                roomId:'',
                tableFloorNav:[{id:'',number:''}],
                tableRoomNav:[{id:'',name:''}],

                currentPage:1,
                pageSize:20,
                total:0,

                lightsTkShowbg:false,
                lightsTkShow:false,
                lightsForm:{
                    name:'',
                    deviceId:'',
                    floorId:'',
                    roomId:'',
                    model:'',
                    gatewayId:'',
                    // type:'0',
                },
                // modelNav:[{id:'0',name:'EC-Z4.0'}],
                lightsFormFloorName:'',
                lightsFormRoomName:'',
                lightTkTitle:'',
                software:'',
                firmware:'',

                batchBrightness:0,
                batchBrightnessShow:false,
                batchColor:0,
                batchColorShow:false,
                websocket:null,
                clientid:null,

                reDataIndex:0,

                centralizedSettingTkShowbg:false,
                centralizedSettingTkShow:false,
                centralizedOption:[],
                centralizedSettingForm:{
                    key1:0,
                    key2:0,
                    key3:0,
                    key4:0,
                    key5:0,
                    key6:0,
                },
                centralizedSettingForm_for:[
                    {title:'Button 1',key:'key1'},
                    {title:'Button 2',key:'key2'},
                    {title:'Button 3',key:'key3'},
                    {title:'Button 4',key:'key4'},
                    {title:'Button 5',key:'key5'},
                    {title:'Button 6',key:'key6'}
                ],

                loading:{
                    lightDataList:false,
                    centralizedSettingSave:false,
                },

                img_lights_0:'',

                updateRemRatioShakeProof:null,
            }
        },
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',

                remRatio:'remRatio',
                updateRemRatio:'updateRemRatio',

                role:'role',
                countryId:'countryId',
                provinceId:'provinceId',
                cityId:'cityId',
                hotelId:'hotelId',
                headerIdStr:'headerIdStr',
            }),
            // lightsFormModelName(){
            //     let name = '';
            //     for(let d of this.modelNav){
            //         if(d.id == this.lightsForm.model){
            //             name = d.name
            //         }
            //     }
            //     return name
            // }
        },
        components:{
            // 'sideBar':sideBar
        },
        beforeDestroy(){
            if(this.websocket){
                this.websocket.close();
            }
        },
        mounted(){
            this.img_lights_0 = require('../../img/room/map/lights_0.png');

            if(this.version == '1'){
                this.img_lights_0 = require('../../img/room/map/lights_0_v1.png');
            }
            this.alertsArr = [this.$t('App.room_light.text59'),this.$t('App.room_light.text60')];
            this.onlineArr = [this.$t('App.room.text65'),this.$t('App.room.text66')];
            this.chartTypeArr = [{label:this.$t('App.room_light.text61'),value:'0',str:'line'},{label:this.$t('App.room_light.text62'),value:'1',str:'bar'}];

            this.timeTypeStr = this.$t('App.room_light.text63');
            this.timeTypeArr = [{label:this.$t('App.room_light.text63'),value:'0'},{label:this.$t('App.room_light.text64'),value:'4'},{label:this.$t('App.room_light.text65'),value:'1'},{label:this.$t('App.room_light.text66'),value:'2'}];

            this.floorName = this.$t('App.room.text29');
            this.roomName = this.$t('App.room.text30');
            
            // this.centralizedSettingForm_for = [
            //     {title:this.$t('App.lights.text39'),lightKey:'open_light',colorKey:'open_color'},
            //     {title:this.$t('App.lights.text40'),lightKey:'close_light',colorKey:'close_color'},
            //     {title:this.$t('App.lights.text41'),lightKey:'att_class_light',colorKey:'att_class_color'},
            //     {title:this.$t('App.lights.text42'),lightKey:'fin_class_light',colorKey:'fin_class_color'},
            //     {title:this.$t('App.lights.text43'),lightKey:'break_light',colorKey:'break_color'},
            //     {title:this.$t('App.lights.text44'),lightKey:'self_stu_light',colorKey:'self_stu_color'},/*自习*/
            //     {title:this.$t('App.lights.text45'),lightKey:'blackboard_light',colorKey:'blackboard_color'},
            //     {title:this.$t('App.lights.text46'),lightKey:'shadow_light',colorKey:'shadow_color'},
            // ];

            this.centralizedSettingForm_for= [
                {title:this.$t('App.lights.text50')+' 1',key:'key1'},
                {title:this.$t('App.lights.text50')+' 2',key:'key2'},
                {title:this.$t('App.lights.text50')+' 3',key:'key3'},
                {title:this.$t('App.lights.text50')+' 4',key:'key4'},
                {title:this.$t('App.lights.text50')+' 5',key:'key5'},
                {title:this.$t('App.lights.text50')+' 6',key:'key6'}
            ];

            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:true,
            })
            this.lightArr = [
                {prop:'online',label:this.$t('App.lights.text30'),minWidth:8*this.remRatio,type:1},
                {prop:'alarmStatus',label:this.$t('App.lights.text31'),minWidth:10.5*this.remRatio,type:1},
                {prop:'updateTime',label:this.$t('App.lights.text32'),width:10.5*this.remRatio},
            ];
            // this.centralizedOption = [
            //     {id:1,name:'全开模式'},
            //     {id:2,name:'全关模式'},
            //     {id:3,name:'投影模式'},
            //     {id:4,name:'自习模式'},
            //     {id:5,name:'板书模式'},
            //     {id:6,name:'上课模式'},
            //     {id:7,name:'下课模式'},
            //     {id:8,name:'投影模式'}
            // ];
                    // {title:'Full-on mode',lightKey:'open_light',colorKey:'open_color'},
                    // {title:'Full-off mode',lightKey:'close_light',colorKey:'close_color'},
                    // {title:'Attend class mode',lightKey:'att_class_light',colorKey:'att_class_color'},
                    // {title:'Finish class mode',lightKey:'fin_class_light',colorKey:'fin_class_color'},
                    // {title:'Noon break mode',lightKey:'break_light',colorKey:'break_color'},
                    // {title:'Self-study mode',lightKey:'self_stu_light',colorKey:'self_stu_color'},/*自习*/
                    // {title:'Blackboard mode',lightKey:'blackboard_light',colorKey:'blackboard_color'},
                    // {title:'Projection mode',lightKey:'shadow_light',colorKey:'shadow_color'},
            // this.centralizedOption = [
            //     {id:'1',name:'Full-on mode'},
            //     {id:'2',name:'Full-off mode'},
            //     {id:'3',name:'Projection mode'},
            //     {id:'4',name:'Self-study mode'},
            //     {id:'5',name:'Blackboard mode'},
            //     {id:'6',name:'Attend class mode'},
            //     {id:'7',name:'Finish class mode'},
            //     {id:'8',name:'Noon break mode'}
            // ];
            this.get_model_nav();
            
            this.getBuildNav(()=>{
                if(this.buildNav.length > 0){
                    this.buildId = this.buildNav[0].id;
                    this.tableFloorNav = [{id:'',name:''}];
                    this.getFloorNav(data=>{
                        for(let d of data.data.list){
                            this.tableFloorNav.push(d)
                        }
                    })
                    this.getLightList();
                }else{
                    this.buildId = '';
                }
            });
            let this_ = this;
            base.websocket_close(allUrl.websocket.ws,websocket=>{
                // console.log(websocket)
                this.websocket = websocket;
                this.websocket.send('{"type":"cmd"}');
                websocket.onmessage = event => {
                    console.log(JSON.parse(event.data));
                    let data = JSON.parse(event.data)
                    if(data.code == '0000'){
                        if(data.data.status == '1'){
                            this.clientid = data.data.clientid
                        }
                        if(data.data.status == '2'){
                            if(data.data.type == 'set_light'){
                                this.$notify({
                                    title: data.msg,
                                    message: this.$t('App.room_light.text70')+data.data.name,
                                    type: 'success'
                                });
                                for(let d of this.lightDataList){
                                    if(d.id == data.data.id){
                                        d.brightnessLoading = false;
                                        d.brightness = d.brightness_;
                                    }
                                }
                            }
                            if(data.data.type == 'set_color'){
                                this.$notify({
                                    title: data.msg,
                                    message: this.$t('App.room_light.text70')+data.data.name,
                                    type: 'success'
                                });
                                for(let d of this.lightDataList){
                                    if(d.id == data.data.id){
                                        d.colorLoading = false;
                                        d.color = parseInt(d.color_);
                                    }
                                }
                            }
                            if(data.data.type == 'delete'){
                                this.$notify({
                                    title: data.msg,
                                    message: this.$t('App.room_light.text70')+data.data.name,
                                    type: 'success'
                                });
                                this.getLightList();
                            }
                            if(data.data.type == 'string'){
                                this.$notify({
                                    title: data.msg,
                                    message: this.$t('App.room_light.text70')+data.data.name,
                                    type: 'success'
                                });
                                for(let d of this.lightDataList){
                                    if(d.id == data.data.id){
                                        d.Plight_0 = d.Plight_0_;
                                        d.Plight_1 = d.Plight_1_;
                                        d.Plight_2 = d.Plight_2_;
                                        d.Plight_3 = d.Plight_3_;
                                        d.Plight_4 = d.Plight_4_;
                                        d.Plight_5 = d.Plight_5_;
                                        d.PlightLoading = false;
                                    }
                                }
                            }
                            if(data.data.type == 'ref_data'){
                                this.$notify({
                                    title: data.msg,
                                    message: this.$t('App.room_light.text70')+data.data.name,
                                    type: 'success'
                                });
                                this.reDataIndex--;
                                if(this.reDataIndex<0){
                                    this.reDataIndex = 0;
                                }
                                this.getLightList();
                            }
                            if(data.data.type == 'school_set_panel_mode'){
                                this.$message({
                                  showClose: true,
                                  message: data.msg,
                                  type: 'success'
                                });
                                this.centralizedSettingTkShow = false;
                                setTimeout(function(){
                                    this_.centralizedSettingTkShowbg = false;
                                },400)
                                this.loading.centralizedSettingSave = false;
                                this.getLightList();
                            }
                        }
                    }else{
                        this.$alert(data.msg, this.$t('App.message.text1'), {
                            confirmButtonText: this.$t('App.message.text2'),
                        });
                        if(data.data.status == '2'){
                            if(data.data.type == 'set_light'){
                                for(let d of this.lightDataList){
                                    if(d.id == data.data.id){
                                        d.brightness_ == d.brightness;
                                        d.brightnessLoading = false;
                                    }
                                }
                            }
                            if(data.data.type == 'set_color'){
                                for(let d of this.lightDataList){
                                    if(d.id == data.data.id){
                                        d.color_ = d.color;
                                        d.colorLoading = false;
                                    }
                                }
                            }
                            if(data.data.type == 'string'){
                                for(let d of this.lightDataList){
                                    if(d.id == data.data.id){
                                        d.Plight_0_ = parseInt(d.Plight_0);
                                        d.Plight_1_ = parseInt(d.Plight_1);
                                        d.Plight_2_ = parseInt(d.Plight_2);
                                        d.Plight_3_ = parseInt(d.Plight_3);
                                        d.Plight_4_ = parseInt(d.Plight_4);
                                        d.Plight_5_ = parseInt(d.Plight_5);
                                        d.PlightLoading = false;
                                    }
                                }
                            }
                            if(data.data.type == 'school_set_panel_mode'){
                                this.loading.centralizedSettingSave = false;
                            }
                        }
                    }
                }
            },this)
        },
        methods:{
            linkToFun(val,data){
                if(val == '/service'){
                    if(data.alarmStatus == 1){
                        let disConnectTime = '';
                        if(data.disConnectTime){
                           disConnectTime =  data.disConnectTime.format("YYYY-mm-dd");
                        }
                        this.$router.push({path:val+'?floorId='+data.floorId+'&roomId='+data.roomId+'&deviceType=0'+'&daysDate='+disConnectTime});
                    }
                }
            },
            buildIdChange(){
                // this.getLightList();
                this.tableFloorNav = [{id:'',name:''}];
                this.getFloorNav(data=>{
                    for(let d of data.data.list){
                        this.tableFloorNav.push(d)
                    }
                })
                this.currentPage = 1;
                this.getLightList();
            },
            get_model_nav(){
                base.ajax_post(
                    allUrl.smartCampus.get_model_nav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                    },
                    {},
                    data=>{
                        this.centralizedOption = data.data.list;
                    },
                    this
                )
            },

            commandHide(val){
                this.$nextTick(function(){
                    if($('.'+val)&&$('.'+val+' >.select').offset()){
                        $('.'+val).animate({scrollTop: $('.'+val).scrollTop() + $('.'+val+' >.select').offset().top - $('.'+val).offset().top - 100})
                    }
                })
            },
            batchBrightnessShowFun(){
                if(this.checkList.length == 0){
                    this.$message({
                      showClose: true,
                      message: this.$t('App.message.text11'),
                      type: 'warning'
                    });
                    this.batchBrightnessShow = false;
                }else{
                    this.batchBrightness = 0;
                }
            },
            tableEnter(data){
              this.tableShowId = data.id;
            },
            tableLeave(){
              this.tableShowId = '-1';
            },
            /*设备批量调光*/
            batchLampLight(val){
                if(this.checkList.length == 0){
                    this.$message({
                      showClose: true,
                      message: this.$t('App.message.text11'),
                      type: 'warning'
                    });
                }else{
                    let lightId = '';
                    for (let i = this.checkList.length - 1; i >= 0; i--) {
                        for(let d of this.lightDataList){
                            if(d.id == this.checkList[i]){
                                let isTrue = false;
                                if(d.model == '4'||d.model == '5'||d.model == '6'){
                                    isTrue = true;
                                }else{
                                    if(d.online==0){
                                        this.$notify({
                                            message: this.$t('App.message.text12')+d.name+this.$t('App.message.text13'),
                                            type: 'warning'
                                        });
                                        this.batchColorShow = false;
                                        this.checkList.splice(this.checkList.indexOf(this.checkList[i]),1);
                                        this.handleCheckedCitiesChange(this.checkList)
                                        return
                                    }else if(d.blueStatus==0){
                                        this.$notify({
                                            message: this.$t('App.message.text12')+d.name+this.$t('App.message.text14'),
                                            type: 'warning'
                                        });
                                        this.batchColorShow = false;
                                        this.checkList.splice(this.checkList.indexOf(this.checkList[i]),1);
                                        this.handleCheckedCitiesChange(this.checkList)
                                        return
                                    }else{
                                        isTrue = true;
                                    }
                                }
                                if(isTrue){
                                    d.brightness_ = val;
                                    if(lightId == ''){
                                        lightId = this.checkList[i];
                                    }else{
                                        lightId += ','+this.checkList[i];
                                    }
                                    d.brightnessLoading = true
                                }
                            }
                        }
                    }
                    this.batchBrightnessShow = false;
                    base.ajax_postWs(
                        allUrl.smartCampus.set_light,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            id:lightId,
                            light:val,
                            clientId:this.clientid,
                        },
                        this
                    )
                }
            },
            /*设备单独调光*/
            postLampLight(data){
                if(!data.brightnessLoading){
                    let isTrue = false;
                    if(data.brightness != data.brightness_){
                        if(data.model == '4'||data.model == '5'||data.model == '6'){
                            isTrue = true;
                        }else{
                            if(data.online == 0){
                                this.$notify({
                                    message: this.$t('App.message.text9'),
                                    type: 'warning'
                                });
                                data.brightness_ = data.brightness;
                            }else if(data.blueStatus==0){
                                this.$notify({
                                    message: this.$t('App.message.text15'),
                                    type: 'warning'
                                });
                                data.brightness_ = data.brightness;
                            }else{
                                isTrue = true;
                            }
                        }
                        if(isTrue){
                            data.brightnessLoading = true;
                            base.ajax_postWs(
                                allUrl.smartCampus.set_light,
                                {
                                    username:this.username,
                                    client_key:this.client_key,
                                    token:this.token,
                                    id:data.id,
                                    light:parseInt(data.brightness_),
                                    clientId:this.clientid,
                                },
                                this
                            )
                        }
                    }
                }
            },
            /*设备单通道调光*/
            postLightLightStd(data){
                if(!data.PlightLoading){
                    let isTrue = false;
                    if(data.model == '4'||data.model == '5'||data.model == '6'){
                        isTrue = true;
                    }else{
                        if(data.online == 0){
                            this.$notify({
                                message: this.$t('App.message.text9'),
                                type: 'warning'
                            });
                        }else if(data.blueStatus==0){
                            this.$notify({
                                message: this.$t('App.message.text15'),
                                type: 'warning'
                            });
                        }else{
                            isTrue = true;
                        }
                    }
                    if(isTrue){
                        data.PlightLoading = true;
                        base.ajax_postWs(
                            allUrl.roomLight.lightLightStd,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                lightid:data.id,
                                light_0:parseInt(data.Plight_0_),
                                light_1:parseInt(data.Plight_1_),
                                light_2:parseInt(data.Plight_2_),
                                light_3:parseInt(data.Plight_3_),
                                light_4:parseInt(data.Plight_4_),
                                light_5:parseInt(data.Plight_5_),
                                clientId:this.clientid,
                            },
                            this
                        )
                    }
                }
            },

            floorTypeFun(){
                this.$refs.floorRef.selectOption()
            },
            roomTypeFun(){
                this.$refs.roomRef.selectOption()
            },
            floorIdChange(val){
                for(let d of this.tableFloorNav){
                    console.log(val,d.id)
                    if(d.id == val){
                        this.$set(this,'floorName',d.name)
                        console.log(this.floorName)
                    }
                }
                if(val == ''){
                    this.floorName = 'Floor'
                }
                this.tableRoomNav = [{id:'',name:''}];
                if(this.floorId){
                    this.getRoomNav(this.floorId,data=>{
                        for(let d of data.data.list){
                            this.tableRoomNav.push(d)
                        }
                    })
                }
                this.currentPage = 1;
                this.getLightList();
            },
            roomIdChange(val){
                for(let d of this.tableRoomNav){
                    console.log(d.id,val)
                    if(d.id == val){
                        this.$set(this,'roomName',d.number)
                        console.log(this.roomName)
                    }
                }
                if(val == ''){
                    this.roomName = 'Room'
                }
                this.currentPage = 1;
                this.getLightList();
            },
            /*编辑设备*/
            editFun(item){
                this.lightTkTitle = this.$t('App.lights.text36');
                this.lightsTkShowbg = true;
                for(let key in this.lightsForm){
                    this.lightsForm[key] = item[key];
                }
                this.software = item.software;
                this.firmware = item.firmware;
                if(!this.lightsForm.gatewayId){
                    this.lightsForm.gatewayId = '00000000'
                }
                this.lightId = item.id;
                this.getFloorNav(data=>{
                    this.floorNav = data.data.list;
                    for(let d of this.floorNav){
                        if(d.id == this.lightsForm.floorId){
                            this.lightsFormFloorName = d.name;
                        }
                    }
                })
                this.getRoomNav(this.lightsForm.floorId,data=>{
                    this.roomNav = data.data.list;
                    for(let d of this.roomNav){
                        // console.log(d,this.lightsForm.roomId)
                        if(d.id == this.lightsForm.roomId){
                            this.lightsFormRoomName = d.number;
                        }
                    }
                });
                this.$nextTick(function(){
                    this.lightsTkShow = true;
                })
            },
            getGatewayList(callback){
                if(this.buildId){
                    this.loading.gatewayDataList = true;
                    base.ajax_post(
                        allUrl.gateway.getlist,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            buildId:this.buildId,
                            // roomId:this.roomId,
                            page:1,
                            count:10,
                            type:'0',
                            // keywords:this.keywords,
                        },
                        {},
                        data=>{
                            if(callback){
                                callback(data)
                            }
                        },
                        this
                    )
                }
            },
            /*添加设备*/
            lightsFun(){
                this.lightTkTitle = this.$t('App.lights.text36');
                this.lightsTkShowbg = true;
                for(let key in this.lightsForm){
                    this.lightsForm[key] = '';
                }
                this.getGatewayList(data=>{
                    if(data.data.list.length>0){
                        this.lightsForm.gatewayId = data.data.list[0].gatewayId;
                    }
                })
                this.lightsForm.model = 0;
                this.lightsFormFloorName = '';
                this.lightsFormRoomName = '';
                this.lightId = '0';
                console.log(this.buildId)
                this.getFloorNav(data=>{
                    this.floorNav = data.data.list;
                    if(this.floorNav.length > 0){
                        this.lightsForm.floorId = this.floorNav[0].id;
                        for(let d of this.floorNav){
                            if(d.id == this.lightsForm.floorId){
                                this.lightsFormFloorName = d.name;
                            }
                        }
                        this.getRoomNav(this.lightsForm.floorId,data=>{
                            this.roomNav = data.data.list;
                            if(this.roomNav.length > 0){
                                this.lightsForm.roomId = this.roomNav[0].id;
                                for(let d of this.roomNav){
                                    if(d.id == this.lightsForm.roomId){
                                        this.lightsFormRoomName = d.number;
                                    }
                                }
                            }
                        });
                    }
                })
                this.$nextTick(function(){
                    this.lightsTkShow = true;
                })
            },
            lightsTkClose(){
                let this_ = this;
                this.lightsTkShow = false;
                setTimeout(function(){
                    this_.lightsTkShowbg = false;
                },400)
            },
            commandModel(data){
                this.lightsForm.model = data.id;
            },
            commandFloor(data){
                this.lightsForm.floorId = data.id;
                this.lightsFormFloorName = data.name;
                this.getRoomNav(this.lightsForm.floorId,data=>{
                    this.roomNav = data.data.list;
                    this.lightsForm.roomId = '';
                    this.lightsFormRoomName = ''
                });
                this.lightsForm.roomId = '';
            },
            commandRoom(data){
                this.lightsForm.roomId = data.id;
                this.lightsFormRoomName = data.number;
            },
            postSaveLight(){
                let this_ = this;
                base.ajax_post(
                    allUrl.smartCampus.save_light,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        lightId:this.lightId,
                        type:'7',
                        ...this.lightsForm
                    },
                    {},
                    data=>{
                        this.getLightList();
                        this.lightsTkShow = false;
                        setTimeout(function(){
                            this_.lightsTkShowbg = false;
                        },400)
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                    },
                    this
                )
            },
            /*情景设置*/
            centralizedSetting(item){
                console.log(item)
                this.lightId = item.id;
                this.centralizedSettingTkShowbg = true;
                this.$nextTick(function(){
                })
                
                base.ajax_post(
                    allUrl.smartCampus.get_panel_mode,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        id:item.id,
                    },
                    {},
                    data=>{
                        for(let key in this.centralizedSettingForm){
                            this.centralizedSettingForm[key] = data.data[key]
                        }
                        this.centralizedSettingTkShow = true;
                    },
                    this,()=>{
                        this.centralizedSettingTkShowbg = false;
                    }
                )
            },
            centralizedSettingTkClose(){
                let this_ = this;
                this.centralizedSettingTkShow = false;
                setTimeout(function(){
                    this_.centralizedSettingTkShowbg = false;
                },400)

            },
            centralizedSettingSave(){
                // let this_ = this;
                if(!this.loading.centralizedSettingSave){
                    this.loading.centralizedSettingSave = true;
                    let centralizedSettingForm = JSON.parse(JSON.stringify(this.centralizedSettingForm));
                    for(let key in centralizedSettingForm){
                        centralizedSettingForm[key] = parseInt(centralizedSettingForm[key]);
                    }
                    base.ajax_postWs(
                        allUrl.smartCampus.set_panel_mode,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            id:this.lightId,
                            ...centralizedSettingForm,
                            clientId:this.clientid,
                        },
                        this
                    )
                    // base.ajax_post(
                    //     allUrl.smartCampus.set_panel_mode,
                    //     {
                    //         username:this.username,
                    //         client_key:this.client_key,
                    //         token:this.token,
                    //         id:this.lightId,
                    //         ...centralizedSettingForm,
                    //     },
                    //     {},
                    //     data=>{
                    //         this.$message({
                    //           showClose: true,
                    //           message: data.msg,
                    //           type: 'success'
                    //         });
                    //         this.centralizedSettingTkShow = false;
                    //         setTimeout(function(){
                    //             this_.centralizedSettingTkShowbg = false;
                    //         },400)
                    //         this.loading.centralizedSettingSave = false;
                    //     },
                    //     this,()=>{
                    //         this.loading.centralizedSettingSave = false;
                    //     }
                    // )
                }
            },
            /*删除设备*/
            postDelLight(obj,type){
                let lightId = '',isTrue = true;
                if(type == 'batch'){
                    if(obj.length == 0){
                        isTrue = false;
                        this.$message({
                            message: this.$t('App.message.text11'),
                            type: 'warning'
                        });
                    }else{
                        for(let id of obj){
                            if(lightId == ''){
                                lightId = id;
                            }else{
                                lightId += ','+id;
                            }
                        }
                    }
                }else{
                    lightId = obj.id;
                }
                if(isTrue){
                    this.$confirm(
                        this.$t('App.message.text16'), this.$t('App.message.text17'), {
                            confirmButtonText: this.$t('App.message.text2'),
                            cancelButtonText: this.$t('App.message.text6'),
                            type: 'warning'
                        }
                    ).then(() => {
                        base.ajax_postWs(
                            allUrl.smartCampus.del_light,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                lightId:lightId,
                                clientId:this.clientid,
                            },
                            this
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('App.message.text18')
                        });          
                    });
                }
            },
            /*设备列表*/
            getLightListKeyUp(e){
                if(e.key == 'Enter'){
                  this.getLightList();
                }
            },
            getLightList(callback){
                if(this.buildId){
                    this.loading.lightDataList = true;
                    base.ajax_post(
                        allUrl.smartCampus.light_list,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            buildId:this.buildId,
                            // roomId:this.roomId,
                            page:this.currentPage,
                            count:this.pageSize,
                            type:'3',
                            keywords:this.keywords,
                            floorId:this.floorId,
                            roomId:this.roomId,
                        },
                        {},
                        data=>{
                            this.lightDataList = data.data.list;
                            this.loading.lightDataList = false;
                            this.total = Number(data.data.total);

                            this.lightDataIdList = [];
                            this.checkList = [];
                            this.isIndeterminate = false;
                            this.checkAll = false;
                            for(let d of this.lightDataList){
                                this.lightDataIdList.push(d.id);
                                this.$set(d,'brightness',Number(d.brightness));
                                this.$set(d,'brightness_',d.brightness);
                                this.$set(d,'color_',d.color);
                                this.$set(d,'brightnessLoading',false);
                                this.$set(d,'colorLoading',false);

                                this.$set(d,'PlightLoading',false);
                                this.$set(d,'Plight_0_',parseInt(d.Plight_0));
                                this.$set(d,'Plight_1_',parseInt(d.Plight_1));
                                this.$set(d,'Plight_2_',parseInt(d.Plight_2));
                                this.$set(d,'Plight_3_',parseInt(d.Plight_3));
                                this.$set(d,'Plight_4_',parseInt(d.Plight_4));
                                this.$set(d,'Plight_5_',parseInt(d.Plight_5));
                            }

                            let i = 1 + (this.currentPage-1)*this.pageSize;
                            for(let d of this.lightDataList){
                                d.webIndex = i;
                                i++;
                            }
                            if(callback){
                                callback(data)
                            }
                            this.$nextTick(function(){
                                this.$refs.lightDataList.doLayout();
                            })
                        },
                        this,()=>{
                            this.loading.lightDataList = false;
                        }
                    )
                    
                }
            },
            /*楼房下拉列表*/
            getBuildNav(callback){
                if(this.hotelId){
                    base.ajax_post(
                        allUrl.room.buildNav,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            hotelId:this.hotelId,
                        },
                        {},
                        data=>{
                            this.buildNav = data.data.list;
                            if(callback){
                                callback(data)
                            }
                        },
                        this
                    )
                }
            },
            /*楼层下拉列表*/
            getFloorNav(callback){
                base.ajax_post(
                    allUrl.room.floorNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                    },
                    {},
                    data=>{
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*楼间下拉列表*/
            getRoomNav(floorId,callback){
                base.ajax_post(
                    allUrl.room.roomNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                        floorId:floorId,
                    },
                    {},
                    data=>{
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.currentPage = 1;
                this.getLightList();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getLightList();
                // console.log(val)
            },

            handleCheckAllChange(val) {
                this.checkList = val ? JSON.parse(JSON.stringify(this.lightDataIdList)) : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value){
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.lightDataIdList.length;
                console.log(checkedCount,this.lightDataIdList.length)
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.lightDataIdList.length;
            },
        },
        watch:{
            hotelId:function(){
                this.getBuildNav(()=>{
                    if(this.buildNav.length > 0){
                        this.buildId = this.buildNav[0].id;
                        this.getFloorNav(data=>{
                            this.tableFloorNav = data.data.list
                        })
                        this.currentPage = 1;
                        this.getLightList();
                    }else{
                        this.buildId = '';
                    }
                });
            },
    //         headerIdStr:function () {
    //             this.getBuildNav(()=>{
                //  if(this.buildNav.length > 0){
                //      this.buildId = this.buildNav[0].id;
    //                     this.getFloorNav(data=>{
    //                         this.tableFloorNav = data.data.list
    //                     })
    //                     this.getLightList();
                //  }else{
    //                     this.buildId = '';
    //                 }
                // });
    //         },
            updateRemRatio:function(){
                clearTimeout(this.updateRemRatioShakeProof)
                this.updateRemRatioShakeProof = setTimeout(()=>{
                    this.lightArr = [
                        {prop:'online',label:this.$t('App.lights.text30'),minWidth:8*this.remRatio,type:1},
                        {prop:'alarmStatus',label:this.$t('App.lights.text31'),minWidth:10.5*this.remRatio,type:1},
                        {prop:'updateTime',label:this.$t('App.lights.text32'),width:10.5*this.remRatio},
                    ];
                    this.$nextTick(function(){
                        this.$refs.lightDataList.doLayout();
                    })
                },1000)
            }
        }
    }
</script>

<style type="text/css" lang="less">

    .switchPanel_main{
        width: 100%;
        height: 100%;
        // height: 105rem;
        min-height: 50rem;
        // min-width: 120rem;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        display: flex;
        background: #F6F8FA;
        &.cn{
            .switchPanel_right{
                .switchPanel_right_top .right_top_l > .el-input .el-icon-search{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
                .switchPanel_right_main .main_cont{
                    .el-table .brightness .btn_img .bg{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .el-table .btn:hover i{
                        color: #8266C7;
                    }
                    .pagination_box .el-pager li{
                        &:hover{
                            color: #513C93;
                            background:rgba(130,102,199,0.1);
                        }
                        &.active{
                            color: #FFFFFF;
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                }
            }
            .switchPanel_wrap .switchPanel_box .btn_box .btn{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
            }
            .centralizedSetting_wrap .centralizedSetting_box .btn_box .btn{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
            }
        }
        .switchPanel_left{
            width: 11.67rem;
            height: 100%;
            min-width: 130px;
        }
        .switchPanel_right{
            position: relative;
            padding: 1.92rem 1.5rem 0;
            width: calc(100% - 11.67rem);
            height: calc(100%);
            .switchPanel_right_top{
                display: flex;
                justify-content: space-between;
                .right_top_l{
                    .el-input__inner{
                        height: 2.5rem;line-height: 2.5rem;
                        border-radius: 1.25rem;
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #333333;
                        border-color: #F0F0F0;
                    }
                    .el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    .el-select{
                        width: 15rem;
                    }
                    >.el-input{
                        margin-left: 1rem;
                        width: 20rem;
                        .el-icon-search{
                            display: inline-block;
                            top: 0;bottom: 0;
                            right: 0;
                            width: 4rem;
                            background: #05CFAB;
                            border-radius: 1.25rem;
                            cursor: pointer;
                            color: #FFFFFF;
                        }
                        .el-input__suffix{
                            right: 0;
                        }
                    }
                }
            }
            .switchPanel_right_main{
                height: calc(100% - 6.5rem);
                margin-top: 1rem;
                position: relative;
                background: #FFFFFF;
                border: 1px solid #F0F0F0;
                border-radius: 0.4rem;
                .main_top{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 1.67rem 0;
                    .main_top_l{
                        .div1{
                            margin-top: 1.5rem;
                            font-family: AlibabaPuHuiTiB;
                            font-size: 1.5rem;
                            color: #333333;
                        }
                        .div2{
                            margin-top: 1.33rem;
                            display: flex;
                            align-items: center;
                            .btn{
                                margin-left: 1.29rem;
                                display: flex;align-items: center;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                                cursor: pointer;
                                i{
                                    font-size:1rem;
                                    color: #C6CDD5;
                                }
                                span{
                                    margin-left: 0.5rem;
                                }
                            }
                        }
                    }
                    .main_top_r{
                        margin-top: 2.33rem;
                        display: flex;
                        .btn{
                            margin-left: 1rem;
                            height: 2.5rem;line-height: 2.5rem;
                            padding: 0 1.25rem;
                            background: #FFFFFF;
                            border: 1px solid #F0F0F0;
                            border-radius: 1.25rem;
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            img{
                                margin-right: 0.5rem;
                                height: 1rem;
                            }
                        }
                    }
                }
                .main_cont{
                    height: calc(100% - 11rem);
                    margin-top: 0.75rem;
                    .el-checkbox-group{
                        height: 100%;
                    }
                    .el-table{
                        .el-checkbox{
                            margin-left: 1.1rem;
                        }
                        .btn{
                            padding: 0.5rem;
                            cursor: pointer;
                            &+.btn{
                                margin-left: 0.2rem;
                            }
                            i{
                                color: #A3AFBB;
                                font-size:0.8rem;
                            }
                            &:hover{
                                i{
                                    color: #05CFAB;
                                }
                            }
                        }
                        th{
                            font-weight:initial;
                            height: 3rem;
                            border-top: 1px solid #F0F0F0;
                            border-bottom: 1px solid #F0F0F0;
                            padding: 0;
                            background: #F6F8FA;
                            &>.cell{
                                height: 3rem;line-height: 3rem;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                            }
                            div{
                                height: 3rem;line-height: 3rem;
                            }
                        }
                        td{
                            padding: 0;
                            height: 3rem;
                            &>.cell,.el-checkbox__label{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                                // line-height: 3rem;
                            }
                        }
                        .el-loading-spinner{
                            height: 100%;
                            margin-top: 0;top: 50%;
                        }
                        .cell{
                            .el-loading-spinner{
                                height: 100%;
                                margin-top: 0;top: 0;
                                .circular{
                                    width: 1.5rem;height: 1.5rem;
                                }
                            }
                            
                        }
                        .floor_header{
                            width: 100%;
                            position: relative;
                            cursor: pointer;
                            padding: 0;
                            p{
                                background-color: rgba(246,248,250,1);
                            }
                            .el-select{
                                position: absolute;
                                top: 0;
                                left: 0;
                                z-index: -1;
                                width: 100%;
                            }
                            .el-input__inner{
                                height:2.7rem;line-height:2.7rem;
                                border: none;
                                background-color: inherit;

                                font-size:1.1rem;
                                font-weight:500;
                                font-family:PingFang-SC-Medium,PingFang-SC;
                                color:rgba(142,159,175,1);
                            }
                        }
                        .brightness{
                            display: flex;
                            align-items: center;
                            justify-content:flex-end;
                            height: 3rem;
                            .text{
                                // margin-left: auto;
                                position: relative;
                            }
                            >.loading{
                                display: inline-block !important;
                            }
                            >.input_loading{
                                display: none !important;
                            }
                            &:hover{
                                >.text{
                                    display: none;
                                }
                                .el-input-number{
                                    display: inline-block;
                                }
                            }
                            .el-input-number{
                                display: none;
                                .el-input{
                                    height: 2rem;line-height: 2rem;
                                    .el-input__inner{
                                        height: 2rem;line-height: 2rem;
                                        padding: 0;text-align: center;
                                        font-family: AlibabaPuHuiTiR;
                                        font-size: 1rem;
                                        color: #657085;
                                    }
                                } 
                            }
                            .btn_img{
                                display: block;
                                margin-right: auto;
                                margin-left: 0.58rem;
                                margin-right: 0.5rem;
                                width: 1.5rem;height: 1.5rem;line-height: 1.5rem;
                                background: #05CFAB;
                                border-radius: 0.4rem;
                                background-color:rgba(5,207,171,0.4);
                                position: relative;
                                cursor: pointer;
                                i{
                                    color: #FFFFFF;
                                    font-size:0.7rem;
                                    position: relative;z-index: 1;
                                }
                                &:hover{
                                    i{
                                        top: 0.1rem;
                                        font-size: 1rem;
                                    }
                                }
                                .bg{
                                    position: absolute;
                                    width: 100%;height: 100%;
                                    bottom: 0;left: 0;
                                    background-color:rgba(5,207,171,1);
                                    border-radius: 0.4rem;
                                }
                            }
                            .light_dg{
                                display: block;
                                width: 1.5rem;height: 1.5rem;
                                cursor: pointer;
                                background-image: url('../../img/room/light_dg_0.png');
                                background-size: 100% 100%;
                                background-position: center;
                                color: rgba(0,0,0,0);
                                &:hover{
                                    background-image: url('../../img/room/light_dg_1.png');
                                }
                            }
                        }
                        .color{
                            display: flex;
                            align-items: center;
                            justify-content:center;
                            .text{
                                // margin-left: auto;
                            }
                            .btn_img{
                                display: inline-block;
                                margin-right: auto;
                                margin-left: 0.58rem;
                                width: 1.5rem;height: 1.5rem;line-height: 1.5rem;
                                background: #05CFAB;
                                border-radius: 0.4rem;
                                background-color:rgba(255,190,0,0.4);
                                position: relative;
                                cursor: pointer;
                                // font-size: 12
                                i{
                                    color: #FFFFFF;
                                    font-size:0.7rem;
                                    position: relative;z-index: 1;
                                }
                                &:hover{
                                    i{
                                        top: 0.1rem;
                                        font-size: 1rem;
                                    }
                                }
                                .bg{
                                    position: absolute;
                                    width: 100%;height: 100%;
                                    bottom: 0;left: 0;
                                    background-color:rgba(255,190,0,1);
                                    border-radius: 0.4rem;
                                }
                            }
                        }
                        .alarmStatus{
                            .text_1{
                                cursor: pointer;
                                color: rgba(255,12,77,1);
                                i{
                                    margin-left: 0.2rem;
                                    font-size: 1rem;
                                }
                            }
                        }
                        .online{
                            width: 4.8rem;
                            height: 1.8rem;
                            line-height: 1.8rem;
                            background: rgba(246,248,250,1);
                            border-radius: 0.67rem;
                            margin: 0 auto;
                            span{
                                position: relative;
                                margin: 0 0.3rem;
                                color:rgba(235, 239, 242, 1);
                            }
                            .iconfont{
                                font-size: 1.2rem;
                            }
                        }
                    }
                    .pagination_box{
                        .el-pagination{
                            float: right;
                            margin-top: 0.5rem;
                        }
                        height: 2.5rem;line-height: 2.5rem;
                        .btn-prev .el-icon{
                            font-size:1rem;
                            color: #666666;
                            font-family: PingFang-SC-Medium;
                        }
                        button{
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                        }
                        .el-pager li{
                            margin-left: 0.83rem;
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                            &:hover{
                                color: rgba(5,207,171,1);
                                background-color: rgba(5,207,171,0.1);
                            }
                        }
                        .btn-next{
                            margin-left: 0.83rem;
                        }
                        .el-pager li.active{
                            background: #05CFAB;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
        .switchPanel_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .switchPanel_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .switchPanel_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.switchPanel_tk_show{
                    right: 0rem; 
                }
                .switchPanel_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .gatewayUpdate_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .gatewayUpdate_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .gatewayUpdate_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.gateway_tk_show{
                    right: 0rem; 
                }
                .gatewayUpdate_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .box1{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width:calc(100% - 5rem);
                    height:5.08rem;
                    margin:2.5rem auto 0;
                    padding: 0 1.5rem;
                    background:rgba(246,248,247,1);
                    img{
                        height: 3rem;
                    }
                    span{
                        font-size:1.67rem;
                        font-family:AlibabaPuHuiTiH;
                        color:rgba(51,51,51,1);
                    }
                }
                .p1{
                    width:calc(100% - 5rem);
                    margin:0.75rem auto 0;
                    height:1.42rem;
                    line-height:1.42rem;
                    font-size:1rem;
                    font-family:AlibabaPuHuiTiR;
                    color:rgba(101,112,133,1);
                }
                .btn_box{
                    width:calc(100% - 5rem);
                    margin:2rem auto 0;
                    height:2.67rem;
                    background:rgba(5, 207, 171, 0.1);
                    .btn{
                        width: 100%;height: 100%;line-height: 2.67rem;
                        text-align: center;
                        background:rgba(5,207,171,1);
                        border-radius:0.17rem;

                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        cursor: pointer;
                    }
                    .el-progress{
                        .el-loading-mask{
                            background: rgba(255,255,255,0.1);
                        }
                        .el-progress-bar__outer{
                            height: 2.67rem;
                            background-color:initial;
                            border-radius: 0;
                            .el-progress-bar__inner{
                                border-radius: 0;
                                background-color:rgba(5, 207, 171, 1);
                            }
                        }
                    }
                    .text{
                        width: 100%;height: 100%;line-height: 2.67rem;
                        text-align: center;
                        border-radius:0.17rem;
                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        &.span1{
                            background-color: rgba(255, 12, 77, 1);
                            cursor:pointer;
                        }
                        &.span2{
                            background-color: rgba(165, 201, 195, 1);
                        }
                    }
                }
            }
        }
        .centralizedSetting_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .centralizedSetting_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 68rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .centralizedSetting_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 68rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.centralizedSetting_tk_show{
                    right: 0rem; 
                }
                .centralizedSetting_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin: 3rem 2.5rem 0;
                    .form_item{
                        margin-bottom: 1.67rem;
                        border: 1px solid #EBEFF2;
                        .form_item_title{
                            background: #F6F8F7;
                            height: 3.33rem;line-height:3.33rem;
                            padding-left: 1rem;
                            font-family: PingFang-SC-Bold;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .form_item_box{
                            display: flex;
                            border-top: 1px solid #EBEFF2;
                            .el-select{
                                width: 100%;
                                .el-input--suffix .el-input__inner{
                                    padding-right: 1.5rem;
                                }
                                .el-input__suffix{
                                    right: 1rem;
                                    .el-input__icon{
                                        width: 1.5rem;
                                        line-height:4rem;
                                    }
                                }
                                .el-input__inner{
                                    // text-align: right;
                                    height: 4rem;line-height: 4rem;
                                    border: none;
                                    padding-left: 1.5rem;
                                }
                            }
                        }
                    }
                }
                .btn_box{
                    width:calc(100% - 5rem);
                    margin:2rem auto 0;
                    height:2.67rem;
                    background:rgba(5, 207, 171, 0.1);
                    .btn{
                        width: 100%;height: 100%;line-height: 2.67rem;
                        text-align: center;
                        background:rgba(5,207,171,1);
                        border-radius:0.17rem;

                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        cursor: pointer;
                    }
                }
            }
        }
    }
</style>